import { useEffect } from "react";
import Button from "./Button";

export default function Modal({
  isOpen,
  title,
  children,
  onClose,
  footer,
  maxWidthClass = "max-w-lg",
  heightClass = "",
}) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-birdie-charcoal/40" onClick={() => onClose?.()} />
      <div className="absolute inset-0 flex items-end sm:items-center justify-center p-0 sm:p-4">
        <div className={`w-full sm:w-auto sm:min-w-[400px] ${maxWidthClass} ${heightClass} rounded-t-2xl sm:rounded-2xl bg-white shadow-xl overflow-hidden flex flex-col max-h-[90vh] sm:max-h-[85vh]`}>
          <div className="flex items-center justify-between border-b border-birdie-green/15 px-4 sm:px-5 py-3 sm:py-4 flex-shrink-0">
            <div className="font-accent text-base font-semibold pr-2 text-birdie-charcoal">{title}</div>
            <Button variant="ghost" onClick={() => onClose?.()} aria-label="Close" className="flex-shrink-0">
              ✕
            </Button>
          </div>

          <div className="px-4 sm:px-5 py-4 flex-1 overflow-y-auto">{children}</div>

          {footer ? <div className="border-t border-birdie-green/15 px-4 sm:px-5 py-3 sm:py-4 flex-shrink-0">{footer}</div> : null}
        </div>
      </div>
    </div>
  );
}
